module.exports = __webpack_public_path__ + "img/up5.1283b5df.png";